import React, {useEffect, useState} from "react";

import Input from "antd/es/input";
import Form from "antd/es/form";
import Switch from "antd/es/switch";
import { Select } from "antd";

import { Row, Col } from "components/layout";

const MAX_COUNT = 2;

const BtcForm = ({ form, doorOptions }) => {
  const [selectedDoors, setSelectedDoors] = useState([]);

  useEffect(() => {
    const initialSelectedDoors = form.getFieldValue('connected_doors') || [];
    setSelectedDoors(initialSelectedDoors);
  }, [form]);

  const handleChange = (value) => {
    if (value.length > MAX_COUNT) {
      return;
    }
    setSelectedDoors(value);
  };

  return (
  <Form
    form={form}
    layout="vertical"
    hideRequiredMark={true}
    onFinish={form.onSubmit}
  >
    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item
          label="BTC Name"
          name="name"
          rules={[
            {
              required: true,
              message: "BTC name is required",
            },
          ]}
        >
          <Input placeholder="ex. BTC-DOOR-MA00" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Hardware ID"
          name="hw_id"
          rules={[
            {
              required: true,
              message: "Hardware ID is required",
            },
          ]}
        >
          <Input placeholder="Hardware ID" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item
          label="Model"
          name="model"
          rules={[
            {
              required: true,
              message: "Model is required",
            },
          ]}
        >
          <Input placeholder="Model" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Connected Doors" name="connected_doors">
        <Select
              mode="multiple"
              value={selectedDoors}
              onChange={handleChange}
              placeholder="Select connected doors"
            >
              {doorOptions.map((door) => (
                <Select.Option
                  key={door.value}
                  value={door.value}
                  label={door.label}
                  disabled={selectedDoors.length >= MAX_COUNT && !selectedDoors.includes(door.value)}
                >
                  {door.label}
                </Select.Option>
              ))}
            </Select>
        </Form.Item>
      </Col>
    </Row>

    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item label="Default Message" name="default_msg">
          <Input placeholder="ex. Don't forget to check in" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Additional Params" name="additional_params">
          <Input placeholder="Additional Params" />
        </Form.Item>
      </Col>
    </Row>

    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item
          label="LTR"
          name="is_ltr"
          valuePropName="checked"
          normalize={(checked) => (checked ? 1 : 0)}
        >
          <Switch />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Active"
          name="is_active"
          valuePropName="checked"
          normalize={(checked) => (checked ? 1 : 0)}
        >
          <Switch />
        </Form.Item>
      </Col>
    </Row>

    <Form.Item label="Notes" name="notes">
      <Input.TextArea rows={3} placeholder="Notes" />
    </Form.Item>
  </Form>
 );
}

export default BtcForm;
